import React from "react";
import { Empty as EmptyState } from "../Empty";
import { ErrorState } from "../Error";
import { LoadingState } from "../Loading";
import { BaseTableStatusContainer } from "./styled";
import { jsx as _jsx } from "react/jsx-runtime";
function getStatusComponent(size, status, errorMessage, errorButtonProps, emptyMessage) {
  switch (status) {
    case "error":
      return /*#__PURE__*/_jsx(ErrorState, {
        size: size,
        errorMessage: errorMessage,
        errorButtonProps: errorButtonProps
      });
    case "loading":
      return /*#__PURE__*/_jsx(LoadingState, {});
    case "empty":
      return /*#__PURE__*/_jsx(EmptyState, {
        emptyMessage: emptyMessage
      });
    default:
      return /*#__PURE__*/_jsx(ErrorState, {
        size: size,
        errorMessage: "An error has occurred. The status of the table is invalid",
        errorButtonProps: {
          onClick: null
        }
      });
  }
}

// eslint-disable-next-line import/prefer-default-export
export function TableStatus(_ref) {
  var status = _ref.status,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? "default" : _ref$size,
    errorButtonProps = _ref.errorButtonProps,
    errorMessage = _ref.errorMessage,
    emptyMessage = _ref.emptyMessage;
  return /*#__PURE__*/_jsx(BaseTableStatusContainer, {
    size: size,
    children: getStatusComponent(size, status, errorMessage, errorButtonProps, emptyMessage)
  });
}